<template>
     <gofix-card classContent="mt-25 position-relative finance-budget-info">
        <button type="button" class="icon-button icon-button-edit-card" @click="handleShowModalEdit" v-if="HeaderItem.status != 'Approved'">
            <img width="20" src="img/iconPencil.png" alt="icon-edit" />
        </button>
        <b-row class="mb-19">
            <b-col cols="4">
                <gofix-text-field label="Client Contract" oneline>{{ HeaderItem.client_contract && HeaderItem.client_contract.contract_name ? HeaderItem.client_contract.contract_name : '--' }}</gofix-text-field>
            </b-col>
            <b-col cols="8">
                <gofix-text-field class="width-column" label="Department (BU code)" oneline>{{ HeaderItem.dept_code }}</gofix-text-field>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4">
                <gofix-text-field label="Finance Year Start" oneline>{{ HeaderItem.financial_year_start | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}</gofix-text-field>
            </b-col>
            <b-col cols="8">
                <gofix-text-field class="width-column" label="Financial Year End" oneline disabled>{{ HeaderItem.financial_year_end | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}</gofix-text-field>
            </b-col>
        </b-row>
        <ModalEditBudget 
            v-model="modals.edit.open" 
            :item="data"
            @saveSuccess="reGetHeaderItem"/>
    </gofix-card>
</template>
<script>
    import { mapGetters } from 'vuex';
    const ModalEditBudget = () => import('../modal-edit-budget.vue')
    import moment from 'moment';
    export default {
        name: 'budget-info',
        components: {
            ModalEditBudget
        },
        data() {
            return {
                data: {},
                modals: {
                    edit: {
                        open: false
                    }
                },
            }
        },
        computed: {
            ...mapGetters({
                HeaderItem: 'BudgetAllocationController/headerItem',
            }),
            financial_year_end() {
                if(this.HeaderItem.financial_year_start) {
                   //return moment(this.HeaderItem.financial_year_start).add(11, 'M').format("DD.MM.YYYY");
                   return moment(moment(this.HeaderItem.financial_year_start).add(12, 'M')).subtract(1, 'days').format("DD.MM.YYYY");
                }
                return '--';
            }
        },
        methods: {
            handleShowModalEdit() {
                this.data = JSON.parse(JSON.stringify(this.HeaderItem));
                this.data.financial_year_end = this.HeaderItem.financial_year_start ? moment(this.HeaderItem.financial_year_start).add(12, 'M').format("YYYY-MM-DD") : null;
                this.modals.edit.open = true;
            },
            reGetHeaderItem() {
                this.$emit('reGetHeaderItem')
            }
        }
    }
</script>
